import { render, staticRenderFns } from "./AllocationAll.vue?vue&type=template&id=93a0ec3c&scoped=true&"
import script from "./AllocationAll.vue?vue&type=script&lang=js&"
export * from "./AllocationAll.vue?vue&type=script&lang=js&"
import style0 from "./AllocationAll.vue?vue&type=style&index=0&id=93a0ec3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a0ec3c",
  null
  
)

export default component.exports